module.exports = __webpack_public_path__ + "img/5.6b0a970d.jpg";